import { PlusOutlined } from '@ant-design/icons'
import LoadingOutlined from '@ant-design/icons/lib/icons/LoadingOutlined'
import React from 'react'

const UploadButton: React.FC<{ value: string; loading: boolean }> = ({ value, loading }) => {
  return (
    <>
      {!loading && value ? (
        <img
          src={value}
          alt={value}
          style={{
            objectFit: 'cover',
            borderRadius: '50%',
            width: '60px',
            height: '60px',
          }}
        />
      ) : (
        <button style={{ border: 0, background: 'none' }} type="button">
          {loading ? <LoadingOutlined /> : <PlusOutlined />}
          <div style={{ marginTop: 8, fontSize: 10 }}>Upload</div>
        </button>
      )}
    </>
  )
}

export default UploadButton
